import { render, staticRenderFns } from "./ReservationServiceIcons.vue?vue&type=template&id=428b0ce4&scoped=true&"
import script from "./ReservationServiceIcons.vue?vue&type=script&lang=js&"
export * from "./ReservationServiceIcons.vue?vue&type=script&lang=js&"
import style0 from "./ReservationServiceIcons.vue?vue&type=style&index=0&id=428b0ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428b0ce4",
  null
  
)

export default component.exports